export default "__VITE_ASSET__BijAyi70__"